<body>
  <header class="flex justify-center items-center">
    <img src="cb-logo.svg" />
  </header>
  <main class="loan-page">
    <h1>Co-applicant Invitation</h1>
    <div class="loan-section max-w-500 w-full">
      @if (isLoading) {
        <p class="m-0">Loading invitation…</p>
      } @else {
        @if (message) {
          <p class="m-0">{{ message }}</p>
        }
        @if (error) {
          <p class="m-0 text-err">{{ error }}</p>
        }

        @if (!error) {
          @if (isAuthenticated) {
            <div class="flex justify-between items-center pt-10">
              <app-button [onClick]="goToApplications">Go to applications</app-button>
            </div>
          } @else {
            @if (applicantEmail) {
              <p class="m-0 pt-10">Invited email: <span class="bolded">{{ applicantEmail }}</span></p>
            }
            <div class="flex items-center pt-10" style="gap: 12px;">
              <app-button [onClick]="goToLogin">Sign In</app-button>
              <app-button buttonType="outline" [onClick]="goToSignup">Sign Up</app-button>
            </div>
          }
        }
      }
    </div>
  </main>
</body>

